/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import TableIsEmptyIcon from "@/assets/customIcons/emptyTable/TableIsEmptyIcon";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "@/components/Button/Button";
import Typography from "@mui/material/Typography";

interface NoSchedulesAssignedProps {
  schedulesExists: boolean;
  canManageSchedules: boolean;
  handleClick: () => void;
}

const NoSchedulesAssigned = ({
  schedulesExists,
  canManageSchedules,
  handleClick
}: NoSchedulesAssignedProps) => {
  const { t } = useTranslation();

  const showButton = schedulesExists && canManageSchedules;

  return (
    <div
      css={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: "16px",
        padding: "16px 8px"
      })}
    >
      <TableIsEmptyIcon
        css={css({
          fontSize: "120px"
        })}
      />

      <Typography variant="body1Medium">
        {t("Download monitoring##schedules##no schedules assigned")}
      </Typography>

      {showButton && (
        <Button
          size={BUTTON_SIZES.Small}
          color={BUTTON_COLORS.PrimarySubtle}
          variant={BUTTON_VARIANTS.TextOnly}
          onClick={handleClick}
        >
          {t("Download monitoring##schedules##assign schedules")}
        </Button>
      )}
    </div>
  );
};

export default NoSchedulesAssigned;
